const Token = require('markdown-it/lib/token');

const TAG_NAME = 'chart';
const START_TAG = `[${TAG_NAME}]`;
const END_TAG = `[/${TAG_NAME}]`;

const LIST_INDENT = '  ';

module.exports = (md) => {
  md.block.ruler.before('paragraph', TAG_NAME, (state, startLine, endLine) => {
    const start = state.bMarks[startLine] + state.tShift[startLine];

    if (state.src.charAt(start) !== START_TAG[0]) {
      return false;
    }

    if (state.src.substr(start, START_TAG.length) !== START_TAG) {
      return false;
    }

    let closeFlag = false;
    let closerLine;
    const lines = [];

    for (closerLine = startLine + 1; closerLine <= endLine; closerLine++) {
      const closerStart = state.bMarks[closerLine] + state.tShift[closerLine];
      if (state.src.substr(closerStart, END_TAG.length) === END_TAG) {
        closeFlag = true;
        break;
      }

      lines.push(state.getLines(closerLine, closerLine + 1, state.blkIndent, false));
    }

    if (!closeFlag) {
      return false;
    }

    const content = lines
      .join('\n')
      // Markdown 元来のリスト記法により、3 個以上の空行が含まれるとリストと見なされなくなるため、連続する空行を 2 個までにする
      .replace(/\n{3,}/g, '\n\n')
      .split('\n')
      .map((line) => {
        if (line.startsWith('*')) {
          return line.replace(/^\*/, '-');
        }

        if (line.startsWith('-')) {
          return `${LIST_INDENT}${line}`;
        }

        // リストの 1 行目よりインデントを 1 段階下げることで、リスト内のコンテンツをグルーピングする
        return `${LIST_INDENT}${LIST_INDENT}${line}`;
      })
      .join('\n');

    const parent = state.parentType;
    const lineMax = state.lineMax;

    state.parentType = 'chart';

    const openerToken = state.push('chart_open', 'div', 1);
    openerToken.markup = START_TAG;
    openerToken.attrs = [['class', 'chart']];
    openerToken.block = true;

    const contentTokens = [];
    state.md.block.parse(content, state.md, state.env, contentTokens);

    let subjectOpened = false;
    contentTokens.forEach((t) => {
      if (t.type === 'list_item_open') {
        subjectOpened = true;
      }

      if (subjectOpened && t.type === 'inline') {
        const contents = t.content.split(/\n/);
        const subjectText = contents[0].trim();
        const contentText = contents.splice(1).join('\n').trim();

        const subjectTokenOpener = new Token('chart_subject_open', 'div', 1);
        subjectTokenOpener.attrs = [['class', 'chart__subject']];
        subjectTokenOpener.block = true;

        const subjectToken = new Token('text', '', 0);
        subjectToken.content = subjectText.trim();

        let labelTokenOpener;
        let labelToken;
        let labelTokenCloser;
        const matched = subjectText.match(/\{([^\s]+?)(?: ([^}]+?))?\}/);
        if (matched) {
          const [markup, className, labelName] = matched;
          subjectTokenOpener.attrs = [['class', `chart__subject ${className}`]];

          if (labelName) {
            labelTokenOpener = new Token('chart_subject_label_open', 'span', 1);
            labelTokenOpener.attrs = [['class', 'label']];

            labelToken = new Token('text', '', 0);
            labelToken.content = labelName;
            labelToken.markup = markup;

            labelTokenCloser = new Token('chart_subject_label_close', 'span', -1);
          }

          subjectToken.content = subjectText.replace(markup, '').trim();
        }

        // NOTE: ページ内リンクのために id 属性を付与する
        let subjectElementId = `chart__${subjectToken.content}`;
        if (labelToken) {
          subjectElementId = `chart__${labelToken.content}--${subjectToken.content}`;
        }
        subjectTokenOpener.attrs.push(['id', subjectElementId]);

        const subjectTokenCloser = new Token('chart_subject_close', 'div', -1);
        subjectTokenCloser.block = true;

        const subjectTokens = [];
        subjectTokens.push(subjectTokenOpener);
        if (labelTokenOpener && labelToken && labelTokenCloser) {
          subjectTokens.push(labelTokenOpener, labelToken, labelTokenCloser);
        }
        subjectTokens.push(subjectToken, subjectTokenCloser);

        // paragraph_open -> inline の順番なので paragraph_open の前に入れる
        state.tokens.splice(-1, 0, ...subjectTokens);

        subjectOpened = false;

        t.content = contentText;
      }

      state.tokens.push(t);
    });

    const closerToken = state.push('chart_close', 'div', -1);
    closerToken.markup = END_TAG;
    closerToken.block = true;

    state.parentType = parent;
    state.lineMax = lineMax;
    state.line = closerLine + 1;

    return true;
  });
};
